import {
  SURVEY_WFS_LAYER_SOURCE,
  type SurveyLayerSource,
} from 'types/layerRefresh';
import { buildCacheBustedRefreshUrl } from './layerRefreshUrl';

export { SURVEY_WFS_LAYER_SOURCE, type SurveyLayerSource };

/** Cache-bust WFS coverage URLs so Refresh pulls fresh GeoServer data. */
export function resolveSurveyCoverageRefreshLayerUrl(endPoint: string): string {
  return buildCacheBustedRefreshUrl(endPoint);
}

export function formatSurveyRefreshError(error: unknown): string {
  const raw =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : '';
  const message = raw.toLowerCase();

  if (
    message.includes('timeout') ||
    message.includes('timed out') ||
    message.includes('time-out')
  ) {
    return 'Survey coverage refresh timed out. Please try again.';
  }
  if (
    message.includes('404') ||
    message.includes('not found') ||
    message.includes('does not exist')
  ) {
    return 'Survey coverage data was not found. It may have been removed.';
  }
  if (
    message.includes('504') ||
    message.includes('502') ||
    message.includes('503') ||
    message.includes('bad gateway') ||
    message.includes('unavailable')
  ) {
    return 'Survey coverage service is temporarily unavailable. Please try again.';
  }
  if (
    message.includes('parse') ||
    message.includes('json') ||
    message.includes('unexpected token') ||
    message.includes('invalid geojson') ||
    message.includes('geojson')
  ) {
    return 'Survey coverage data could not be read. Please try again later.';
  }
  if (!raw.trim()) {
    return 'Failed to refresh survey coverage.';
  }
  return 'Failed to refresh survey coverage. Please try again.';
}
